import type { LucideIcon } from 'lucide-react'

import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export function MetricCard({
  icon: Icon,
  label,
  helper,
  value,
  tone,
  isLoading,
}: {
  icon: LucideIcon
  label: string
  helper: string
  value: string
  tone: 'primary' | 'emerald' | 'amber' | 'violet'
  isLoading: boolean
}) {
  const toneClasses = {
    primary: 'border-primary/20 bg-primary/5 text-primary',
    emerald: 'border-emerald-500/20 bg-emerald-500/10 text-emerald-600',
    amber: 'border-amber-500/20 bg-amber-500/10 text-amber-600',
    violet: 'border-violet-500/20 bg-violet-500/10 text-violet-600',
  }
  return (
    <Card className={cn('border shadow-sm', toneClasses[tone])}>
      <CardContent className="space-y-2 p-5">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Icon className="h-5 w-5" />
            <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</p>
          </div>
          <span className="text-xs font-medium text-muted-foreground">{helper}</span>
        </div>
        {isLoading
          ? (
            <div className="space-y-2">
              <Skeleton className="h-8 w-24" />
              <Skeleton className="h-4 w-20" />
            </div>
          )
          : (
            <p className="text-3xl font-bold">{value}</p>
          )}
      </CardContent>
    </Card>
  )
}
